import { formatUtils } from "@/utils";
import { useMemo } from "react";
import { Box, Stack, Text, Tooltip } from "@includes";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ITendency } from "./types";
import { calculateTendance } from "./helpers";
import { useLocale } from "@/context/LocaleProvider";

const Tendency: React.FC<ITendency> = ({ tendanceValues }) => {
  const theme = useTheme();
  const { t }: i18translateType = useTranslation();
  const { locale } = useLocale();

  const { value, isPositive, hide } = useMemo(() => {
    if (tendanceValues) return calculateTendance(tendanceValues, locale);
    return { value: "+ 0", isPositive: true, hide: false };
  }, [tendanceValues]);

  if (hide) return null;

  if (isPositive) {
    return (
      <div>
        <Tooltip title={t("tendency_tooltip")}>
          <Stack
            spacing={1}
            alignItems="center"
            direction="row"
            sx={{
              p: "4px",
              borderRadius: 2,
              background: theme.customPalette.success.complementary,
            }}
          >
            <Box
              component="img"
              src={`/${theme.customPalette.mode}/icons/tendency_positive.svg`}
            />
            <Text textType="success" variant="body2">
              {value}
            </Text>
          </Stack>
        </Tooltip>
      </div>
    );
  }

  return (
    <div>
      <Tooltip title={t("tendency_tooltip")}>
        <Stack
          spacing={1}
          alignItems="center"
          direction="row"
          sx={{
            p: "4px",
            borderRadius: 2,
            background: theme.customPalette.error.complementary,
          }}
        >
          <Box
            component="img"
            src={`/${theme.customPalette.mode}/icons/tendency_negative.svg`}
          />
          <Text textType="error" variant="body2">
            {value}
          </Text>
        </Stack>
      </Tooltip>
    </div>
  );
};

export default Tendency;
